module.exports = __webpack_public_path__ + "img/Weapon_99.18bf63cc.png";